import { BeneficiaryType } from "../../types/BeneficiaryType";
import * as content from "@services/content/guided-flow/account-details-content";

export interface BeneficiaryTypeOption {
  type: BeneficiaryType;
  radioId: string;
  labelText: string;
  description: string;
}

// To add a new beneficiary type:
// 1. Add value to BeneficiaryType enum
// 2. Add entry to BENEFICIARY_TYPE_OPTIONS below
// 3. Create <type>-input-form/ sub-component
// 4. Add ngSwitchCase in input-beneficiary-card.component.html
export const BENEFICIARY_TYPE_OPTIONS: BeneficiaryTypeOption[] = [
  {
    type: BeneficiaryType.INDIVIDUAL_BY_NAME,
    radioId: "bene-type-individual",
    labelText: content.BENEFICIARY_INDIVIDUAL_BY_NAME,
    description: content.BENEFICIARY_INDIVIDUAL_DESC,
  },
  {
    type: BeneficiaryType.TRUST,
    radioId: "bene-type-trust",
    labelText: content.BENEFICIARY_TRUST,
    description: content.BENEFICIARY_TRUST_DESC,
  },
];
